<script setup lang="ts">
import ReportSummaryInspectionDetail from './ReportSummaryInspectionDetail.vue'

interface PropTypes {
  aircraftData: Array<any>
  aircraftLoading: boolean
  inspectionData: Array<any>
  inspectionDataLoading: boolean
  annotationData
  annotationsLoading
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div id="summary-sidebar" class="h-full pb-8">
    <ReportSummaryInspectionDetail 
      :aircraft-data="props.aircraftData" 
      :aircraft-loading="props.aircraftLoading" 
      :inspection-data="props.inspectionData"
      :inspection-data-loading="props.inspectionDataLoading"
      :annotation-data="props.annotationData"
      :annotations-loading="props.annotationsLoading"
    />
  </div>
</template>
